import React from 'react';
import UIStrings from '@/Utils/UIStrings';
import ClientSearch from './ClientSearch';
import ClientAddButton from './ClientAddButton';

const ClientsOverviewHeader = () => (
    <header className="bg-card">
        <div className="container mx-auto px-6 py-8 sm:px-8">
            <div className="flex flex-wrap items-end justify-between gap-6">
                <h1 className="text-foreground text-3xl font-bold tracking-tight">{UIStrings.CompaniesOverview}</h1>
                <div className="flex items-center gap-3">
                    <ClientSearch />
                    <ClientAddButton />
                </div>
            </div>
        </div>
    </header>
);

export default ClientsOverviewHeader;
